import { useEffect, useState } from 'react'
import { searchClientsV2, type ClientSearchItemV2 } from '@/lib/api/v2/clients'

export function useClientSearchV2(params: { q: string; take?: number; includeInactive?: boolean }) {
  const [results, setResults] = useState<ClientSearchItemV2[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    let mounted = true
    const q = params.q.trim()

    /* eslint-disable react-hooks/set-state-in-effect */
    if (!q) {
      setResults([])
      setIsLoading(false)
      setError(null)
      return
    }

    setIsLoading(true)
    setError(null)
    /* eslint-enable react-hooks/set-state-in-effect */

    const t = setTimeout(() => {
      searchClientsV2({ q, take: params.take, includeInactive: params.includeInactive })
        .then((items) => {
          if (!mounted) return
          setResults(items)
        })
        .catch((e) => {
          if (!mounted) return
          setError(e as Error)
          setResults([])
        })
        .finally(() => {
          if (!mounted) return
          setIsLoading(false)
        })
    }, 250)

    return () => {
      mounted = false
      clearTimeout(t)
    }
  }, [params.q, params.take, params.includeInactive])

  return { results, isLoading, error }
}
